import Swiper from 'swiper';
import { Scrollbar } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/css/scrollbar';

export default function servicesFilter(element, data) {   
    // Находим все ссылки-фильтры
    const filterLinks = document.querySelectorAll('.services__filter .item');
    // Находим все элементы
    const servicesItems = document.querySelectorAll('.services__item');

    filterLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();

            // Получаем выбранный город из data-атрибута
            const category = this.getAttribute('data-category');
            // Переключаем активный класс
            document.querySelector('.services__filter .item.active').classList.remove('active');
            this.classList.add('active');

            // Фильтруем 
            servicesItems.forEach(item => {
                const itemcategory = item.getAttribute('data-category_name');
                
                if (category === 'Все' || itemcategory === category) {
                    // item.style.display = '';
                    item.classList.remove('hidden');
                } else {
                    // item.style.display = 'none';
                    item.classList.add('hidden');
                }
                mySwiper.update();
            });
        });
    });

    const  mySwiper = new Swiper(element.querySelector(".swiper-services"), {
        modules: [Scrollbar],
        slidesPerView: 'auto',
        spaceBetween: 15,
        slideClass: 'swiper-slide:not(.hidden-slide)',
        freeMode: {
            enabled: true,
            minimumVelocity: 0.1
        },
        scrollbar: {
            el: '.services-scrollbar',
            draggable: true,
        },
        breakpoints: {
            768: {
                spaceBetween: 40,
            },
            401: {
                spaceBetween: 20,
            },
        }
    });
};